/**
 *    ____ _   _ _____
 *   /___ \ |_(_)___ /  ___
 *  //  / / __| | |_ \ / _ \
 * / \_/ /| |_| |___) |  __/
 * \___,_\ \__|_|____/ \___|
 * Parsa Ghadimi (QTI3E)
 */

import { NextFunction, Request, Response } from "express";

export function normalizeText(text: string): string {
  let tmp = "";
  const len = text.length;
  for (let i = 0; i < len; ++i) {
    switch (text[i]) {
      case "‌":
        tmp += " ";
        break;
      case "۰":
        tmp += "0";
        break;
      case "۱":
        tmp += "1";
        break;
      case "۲":
        tmp += "2";
        break;
      case "۳":
        tmp += "3";
        break;
      case "۴":
        tmp += "4";
        break;
      case "۵":
        tmp += "5";
        break;
      case "۶":
        tmp += "6";
        break;
      case "۷":
        tmp += "7";
        break;
      case "۸":
        tmp += "8";
        break;
      case "۹":
        tmp += "9";
        break;
      case "ي":
      case "ی":
      case "ﯾ":
      case "ﯽ":
      case "ﯿ":
      case "ﻳ":
      case "ى":
      case "ﯾ":
      case "ﯽ":
      case "ﯿ":
      case "ئ":
      case "ﺋ":
      case "ﺊ":
      case "ﺌ":
      case "ي":
      case "ﯾ":
      case "ﯽ":
      case "ﯿ":
      case "ﻴ":
      case "ﻲ":
        tmp += "ی";
        break;
      case "ب":
      case "ﺑ":
      case "ﺐ":
      case "ﺒ":
        tmp += "ب";
        break;
      case "پ":
      case "ﭘ":
      case "ﭗ":
      case "ﭙ":
        tmp += "پ";
        break;
      case "ت":
      case "ﺗ":
      case "ﺖ":
      case "ﺘ":
        tmp += "ت";
        break;
      case "ث":
      case "ﺛ":
      case "ﺚ":
      case "ﺜ":
        tmp += "ث";
        break;
      case "ج":
      case "ﺟ":
      case "ﺞ":
      case "ﺠ":
        tmp += "ج";
        break;
      case "چ":
      case "ﭼ":
      case "ﭻ":
      case "ﭽ":
        tmp += "چ";
        break;
      case "ح":
      case "ﺣ":
      case "ﺢ":
      case "ﺤ":
        tmp += "ح";
        break;
      case "خ":
      case "ﺧ":
      case "ﺦ":
      case "ﺨ":
        tmp += "خ";
        break;
      case "س":
      case "ﺳ":
      case "ﺲ":
      case "ﺴ":
        tmp += "س";
        break;
      case "ش":
      case "ﺷ":
      case "ﺶ":
      case "ﺸ":
        tmp += "ش";
        break;
      case "ص":
      case "ﺻ":
      case "ﺺ":
      case "ﺼ":
        tmp += "ص";
        break;
      case "ض":
      case "ﺿ":
      case "ﺾ":
      case "ﻀ":
        tmp += "ض";
        break;
      case "ط":
      case "ﻃ":
      case "ﻂ":
      case "ﻄ":
        tmp += "ط";
        break;
      case "ظ":
      case "ﻇ":
      case "ﻆ":
      case "ﻈ":
        tmp += "ظ";
        break;
      case "ع":
      case "ﻋ":
      case "ﻊ":
      case "ﻌ":
        tmp += "ع";
        break;
      case "غ":
      case "ﻏ":
      case "ﻎ":
      case "ﻐ":
        tmp += "غ";
        break;
      case "ف":
      case "ﻓ":
      case "ﻒ":
      case "ﻔ":
        tmp += "ف";
        break;
      case "ق":
      case "ﻗ":
      case "ﻖ":
      case "ﻘ":
        tmp += "ق";
        break;
      case "ک":
      case "ﮐ":
      case "ﮏ":
      case "ﮑ":
      case "ﻛ":
      case "ﻜ":
      case "ك":
      case "ﮐ":
      case "ﮏ":
      case "ﮑ":
      case "ﻚ":
        tmp += "ک";
        break;
      case "گ":
      case "ﮔ":
      case "ﮓ":
      case "ﮕ":
        tmp += "گ";
        break;
      case "ل":
      case "ﻟ":
      case "ﻞ":
      case "ﻠ":
        tmp += "ل";
        break;
      case "م":
      case "ﻣ":
      case "ﻢ":
      case "ﻤ":
        tmp += "م";
        break;
      case "ن":
      case "ﻧ":
      case "ﻦ":
      case "ﻨ":
        tmp += "ن";
        break;
      case "ﻻ":
      case "ﻼ":
      case "ﺎ":
        tmp += "لا";
        break;
      case "أ":
      case "إ":
      case "ا":
      case "ﺄ":
        tmp += "ا";
        break;
      case "ﺆ":
      case "ﻮ":
      case "و":
      case "ؤ":
        tmp += "و";
        break;
      case "ﺪ":
      case "د":
        tmp += "د";
        break;
      case "ذ":
      case "ﺬ":
        tmp += "ذ";
        break;
      case "ر":
      case "ﺮ":
        tmp += "ر";
        break;
      case "ز":
      case "ﺰ":
        tmp += "ز";
        break;
      case "ﮋ":
      case "ژ":
        tmp += "ژ";
        break;
      case "ة":
      case "ﮥ":
      case "ه":
      case "ه":
      case "ﻪ":
      case "ﻬ":
      case "ﻩ":
      case "ﻬ":
      case "ﻫ":
      case "ﻪ":
      case "ﻬ":
        tmp += "ه";
        break;
      case "ﷲ":
        tmp += "الله";
        break;
      default:
        tmp += text[i];
    }
  }
  return tmp;
}

export function normalizeBody(
  req: Request,
  res: Response,
  next: NextFunction
): void {
  for (const key in req.body) {
    if (typeof req.body[key] === "string") {
      req.body[key] = normalizeText(req.body[key]).trim();
    } else if (typeof req.body[key] === "number") {
      req.body[key] = String(req.body[key]);
    }
  }
  next();
}

export function toPersian(n: number | string): string {
  const str: string = String(n);
  let txt = "";
  for (let i = 0; i < str.length; ++i) {
    const ch = str[i];
    switch (ch) {
      case "1":
        txt += "۱";
        break;
      case "2":
        txt += "۲";
        break;
      case "3":
        txt += "۳";
        break;
      case "4":
        txt += "۴";
        break;
      case "5":
        txt += "۵";
        break;
      case "6":
        txt += "۶";
        break;
      case "7":
        txt += "۷";
        break;
      case "8":
        txt += "۸";
        break;
      case "9":
        txt += "۹";
        break;
      case "0":
        txt += "۰";
        break;
      default:
        txt += ch;
        break;
    }
  }
  return txt;
}

export function toEnglish(n: number | string): string {
  const str: string = String(n);
  if (typeof n === "number") {
    return str;
  }
  let txt = "";
  for (let i = 0; i < str.length; ++i) {
    const ch = str[i];
    switch (ch) {
      case "۱":
        txt += "1";
        break;
      case "۲":
        txt += "2";
        break;
      case "۳":
        txt += "3";
        break;
      case "۴":
        txt += "4";
        break;
      case "۵":
        txt += "5";
        break;
      case "۶":
        txt += "6";
        break;
      case "۷":
        txt += "7";
        break;
      case "۸":
        txt += "8";
        break;
      case "۹":
        txt += "9";
        break;
      case "۰":
        txt += "0";
        break;
      default:
        txt += ch;
        break;
    }
  }
  return txt;
}

export function isRTL(text: string): boolean {
  const len = text.length;
  for (let i = 0; i < len; ++i) {
    const c = text.charCodeAt(i);
    if (c >= 0x5be && c <= 0x10b7f) {
      if (c <= 0x85e) {
        if (c === 0x5be) return true;
        else if (c === 0x5c0) return true;
        else if (c === 0x5c3) return true;
        else if (c === 0x5c6) return true;
        else if (0x5d0 <= c && c <= 0x5ea) return true;
        else if (0x5f0 <= c && c <= 0x5f4) return true;
        else if (c === 0x608) return true;
        else if (c === 0x60b) return true;
        else if (c === 0x60d) return true;
        else if (c === 0x61b) return true;
        else if (0x61e <= c && c <= 0x64a) return true;
        else if (0x66d <= c && c <= 0x66f) return true;
        else if (0x671 <= c && c <= 0x6d5) return true;
        else if (0x6e5 <= c && c <= 0x6e6) return true;
        else if (0x6ee <= c && c <= 0x6ef) return true;
        else if (0x6fa <= c && c <= 0x70d) return true;
        else if (c === 0x710) return true;
        else if (0x712 <= c && c <= 0x72f) return true;
        else if (0x74d <= c && c <= 0x7a5) return true;
        else if (c === 0x7b1) return true;
        else if (0x7c0 <= c && c <= 0x7ea) return true;
        else if (0x7f4 <= c && c <= 0x7f5) return true;
        else if (c === 0x7fa) return true;
        else if (0x800 <= c && c <= 0x815) return true;
        else if (c === 0x81a) return true;
        else if (c === 0x824) return true;
        else if (c === 0x828) return true;
        else if (0x830 <= c && c <= 0x83e) return true;
        else if (0x840 <= c && c <= 0x858) return true;
        else if (c === 0x85e) return true;
      } else if (c === 0x200f) return true;
      else if (c >= 0xfb1d) {
        if (c === 0xfb1d) return true;
        else if (0xfb1f <= c && c <= 0xfb28) return true;
        else if (0xfb2a <= c && c <= 0xfb36) return true;
        else if (0xfb38 <= c && c <= 0xfb3c) return true;
        else if (c === 0xfb3e) return true;
        else if (0xfb40 <= c && c <= 0xfb41) return true;
        else if (0xfb43 <= c && c <= 0xfb44) return true;
        else if (0xfb46 <= c && c <= 0xfbc1) return true;
        else if (0xfbd3 <= c && c <= 0xfd3d) return true;
        else if (0xfd50 <= c && c <= 0xfd8f) return true;
        else if (0xfd92 <= c && c <= 0xfdc7) return true;
        else if (0xfdf0 <= c && c <= 0xfdfc) return true;
        else if (0xfe70 <= c && c <= 0xfe74) return true;
        else if (0xfe76 <= c && c <= 0xfefc) return true;
        else if (0x10800 <= c && c <= 0x10805) return true;
        else if (c === 0x10808) return true;
        else if (0x1080a <= c && c <= 0x10835) return true;
        else if (0x10837 <= c && c <= 0x10838) return true;
        else if (c === 0x1083c) return true;
        else if (0x1083f <= c && c <= 0x10855) return true;
        else if (0x10857 <= c && c <= 0x1085f) return true;
        else if (0x10900 <= c && c <= 0x1091b) return true;
        else if (0x10920 <= c && c <= 0x10939) return true;
        else if (c === 0x1093f) return true;
        else if (c === 0x10a00) return true;
        else if (0x10a10 <= c && c <= 0x10a13) return true;
        else if (0x10a15 <= c && c <= 0x10a17) return true;
        else if (0x10a19 <= c && c <= 0x10a33) return true;
        else if (0x10a40 <= c && c <= 0x10a47) return true;
        else if (0x10a50 <= c && c <= 0x10a58) return true;
        else if (0x10a60 <= c && c <= 0x10a7f) return true;
        else if (0x10b00 <= c && c <= 0x10b35) return true;
        else if (0x10b40 <= c && c <= 0x10b55) return true;
        else if (0x10b58 <= c && c <= 0x10b72) return true;
        else if (0x10b78 <= c && c <= 0x10b7f) return true;
      }
    }
  }
  return false;
}

interface AntdInputRef {
  input: HTMLInputElement;
}

type InputRef = HTMLInputElement | AntdInputRef;

export function RTLify(ref: InputRef | null): void {
  if (!ref) return;

  let input: HTMLInputElement;
  if (ref instanceof HTMLInputElement) {
    input = ref;
  } else {
    input = ref.input;
  }

  const defaultDir =
    input.dir ||
    (input.placeholder ? (isRTL(input.placeholder) ? "rtl" : "ltr") : false) ||
    document.dir ||
    "ltr";

  const update = () => {
    if (!input.value) {
      input.dir = defaultDir;
    } else if (isRTL(input.value)) {
      input.dir = "rtl";
    } else {
      input.dir = "ltr";
    }
  };

  if (input) {
    update();
    input.onkeydown = input.onkeyup = update;
  }
}
